<template>
<div class="m-loginHeader">
    <div class="m-home">
        <!-- <router-link to="/m/index">
            <div class="icon icon-home"></div>
        </router-link> -->
    </div>
    <div class="m-header">
        <div class="logo img-logo"></div>
    </div>
</div>
</template>

<script>
export default {
    name: 'loginHeader',
    data() {
        return {}
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.m-loginHeader {
    position: relative;
    .m-home{
        position: absolute;
        top: 0.4rem;
        left: 0.32rem;
        .icon{
            width: 0.72rem;
            height: 0.72rem;
        }
    }
    .m-header{
        padding: 1.1rem 0 0.9rem 0;
        display: flex;
        justify-content: center;
        .logo{
            width: 3.15rem;
            height: 0.85rem;
        }
    }
}
</style>